<div class="d-flex">
  <app-tabs-form [activeForm]="activeForm" [account_type]="account_type" [draft]="draft" [role]="role"
    [updatesTabs]="updatesTabs" [document_buttons_chico]="document_buttons_chico"></app-tabs-form>

  <div class="card w-100 form-right">
    <div class="back">
      <h2 *ngIf="!draft">{{ "forms.names.importOrders" | translate }}</h2>

      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form">
          <div>
            <div>
              <div>
                <div class="form-section">
                  <span>{{ "forms.labels.update_order_with_documents" | translate }}</span>

                  <div class="drop-zone" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
                    {{ "forms.labels.draganddrop" | translate }}
                    <input #fileInput type="file" multiple class="input-file-hidden" (change)="onFileInputChange($event)" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <br>
        <p>Puedes importar mediante un fichero xlsx, xls o csv que contenga varias de estas columnas: <br>
          <br>
          - reference (referencia) (obligatorio)<br>
          - stage (etapa/estado del pedido)<br>
          - supplier_reference (Referencia de proveedor)<br>
          - vendor_quote_reference (Referencia de cotización del proveedor)<br>
          - vendor_reference (Referencia del proveedor)<br>
          - vin (bastidor)<br>
          - license_plate (matrícula)<br>
          - delivery_status (estado de la entrega)<br>
          - delivery_expected_date (fecha esperada de entrega)<br>
          - delivery_first_expected_date (primera fecha esperada de entrega)<br>
          - delivery_client_expected_date (fecha de entrega esperada por el cliente)<br>
          - delivery_delay_notes (notas de retraso de entrega)<br>
          - delivery_address (dirección de entrega)<br>
          - delivery_postal_code (código postal de entrega)<br>
          - delivery_city (ciudad de entrega)<br>
          - delivery_state (provincia/estado de entrega)<br>
          - delivery_place (Lugar de entrega)<br>
          - delivery_urgency (urgencia de entrega)<br>
          - delivery_appointment_date (Cita concertada para entrega)<br>
          - delivery_date (Fecha real de entrega)<br>
          - delivery_current_location (Ubicación actual del vehículo)<br>
          - delivery_dealer (Concesión de entrega)<br>
          - delivery_contact (Contacto para entrega)<br>
          - delivery_phone (Teléfono de contacto para entrega)<br>
          - vehicle_model_code (Código del modelo del vehículo)<br>
          - vehicle_discount_code (Código de descuento/campaña)<br>
          - vehicle_billing_date (Fecha de facturación)<br>
          - vehicle_payment_date (Fecha de pago del vehículo)<br>
          - manufacture_expected_date (Fecha esperada de fabricación)<br>
          - vehicle_manufacturing_date (Fecha de fabricación del vehículo)<br>
          - vehicle_registration_date (Fecha de matriculación del vehículo) Formato: "04/03/2026"<br>
          - vehicle_preparation_document_date (Fecha de documentación de preparación)<br>

          <br>
          Si tu fichero contiene otras columnas, no serán tenidas en cuenta.
        </p>
      </div>
      <div class="div-form"></div>

      <!--    <div class="btn-send d-flex align-items-center justify-content-between w-100 ml-4">
        <button *ngIf="!draft" type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()"></button>
      </div> -->
    </div>
  </div>
</div>
